import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const description: SxStyle = {
  lineHeight: 1.5,
};
